import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const persistConfig = {
  key: 'root', // The key to use for storing the data in storage
  storage, // Use localStorage as the storage engine
  // Optionally we can whitelist or blacklist reducers here:
  // whitelist: ['reducerNameToPersist'], // can house data we want all the time
  // blacklist: ['reducerNameToExclude'], // optional data
};

export { persistStore, persistReducer, persistConfig };
